import React from 'react'

import { UserFilter } from '../TableHeader/FilterTypes'
import HoverTooltip from '../../../../../components/HoverTooltip'

type Props = {
    role: string // Роль
    stage: string // Стадия
    isSelect: boolean // Выбрана
    isSendPerf: boolean // Исполнение отправлено
    isLoading: boolean // Обновление из ЕИС
    multiSelect: boolean
    filter: UserFilter | null
    theme: string
    actions: Actions // Функции кнопок
}

// Функции кнопок
type Actions = {
    ready_to_sent: () => void // Подготовка к отправке
    return_to_edit: () => void // Вернуть на Редактирование
    ready_to_eis: () => void // Отправка в ЕИС
    return_to_ready: () => void // Вернуть на Подготовка к отправке
    upload: () => void // Отправка исполнения
    update: () => void // Обновление исполнения
    delete: () => void // Удаление исполнения
    filter: () => void // Фильтр
}

type ButtonConfig = {
    id: string
    label: string
    onClick: () => void
    visibleCondition: boolean // Функция, проверяющая видимость
    className?: string // Стили для кнопки
    iconPathD: string
    iconFill: string
    disabled: boolean
    isLoading: boolean
}

const TableStageToolbarButtons: React.FC<Props> = ({
    role,
    stage,
    isSelect,
    isLoading,
    isSendPerf,
    multiSelect,
    filter,
    theme,
    actions,
    // status,
    // multiSelect,
}) => {
    const isAdmin = role === 'admin'
    const isSpecialist = role === 'specialist'
    const isCurator = role === 'curator'
    const isInitiator = role === 'initiator'

    const isEditStage = stage === 'Редактирование'
    const isRaedyStage = stage === 'Подготовка к размещению'
    const isSentToEisStage = stage === 'Отправка в ЕИС'
    const isPerfInEisStage = stage === 'Размещенное исполнение'

    const isFilter = filter?.filter_settings?.filter_enabled || false

    const buttons: ButtonConfig[] = [
        {
            id: 'ready_to_sent',
            label: 'Направить на подготовку к размещению',
            onClick: actions.ready_to_sent,
            visibleCondition: (isAdmin || isSpecialist) && isEditStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${
                isSelect ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''
            }`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'return_to_edit',
            label: 'Вернуть',
            onClick: actions.return_to_edit,
            visibleCondition: (isAdmin || isSpecialist) && isRaedyStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,11H9.41l2.3-2.29a1,1,0,1,0-1.42-1.42l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H21a1,1,0,0,0,0-2ZM3,3A1,1,0,0,0,2,4V20a1,1,0,0,0,2,0V4A1,1,0,0,0,3,3Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'ready_to_eis',
            label: 'Подготовить к отправке в ЕИС',
            onClick: actions.ready_to_eis,
            visibleCondition: (isAdmin || isSpecialist) && isRaedyStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M17.71,11.29l-4-4a1,1,0,1,0-1.42,1.42L14.59,11H3a1,1,0,0,0,0,2H14.59l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-.33,1,1,0,0,0,0-.76A1,1,0,0,0,17.71,11.29ZM21,4a1,1,0,0,0-1,1V19a1,1,0,0,0,2,0V5A1,1,0,0,0,21,4Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'return_to_ready',
            label: 'Вернуть',
            onClick: actions.return_to_ready,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && !isSendPerf ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && !isSendPerf ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M21,11H9.41l2.3-2.29a1,1,0,1,0-1.42-1.42l-4,4a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l4,4a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H21a1,1,0,0,0,0-2ZM3,3A1,1,0,0,0,2,4V20a1,1,0,0,0,2,0V4A1,1,0,0,0,3,3Z',
            disabled: !isSelect || isSendPerf,
            isLoading: false,
        },
        {
            id: 'upload',
            label: 'Отправить в ЕИС',
            onClick: actions.upload,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect && !isSendPerf ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect && !isSendPerf ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M20.34,9.32l-14-7a3,3,0,0,0-4.08,3.9l2.4,5.37h0a1.06,1.06,0,0,1,0,.82l-2.4,5.37A3,3,0,0,0,5,22a3.14,3.14,0,0,0,1.35-.32l14-7a3,3,0,0,0,0-5.36Zm-.89,3.57-14,7a1,1,0,0,1-1.35-1.3l2.39-5.37A2,2,0,0,0,6.57,13h6.89a1,1,0,0,0,0-2H6.57a2,2,0,0,0-.08-.22L4.1,5.41a1,1,0,0,1,1.35-1.3l14,7a1,1,0,0,1,0,1.78Z',
            disabled: !isSelect || isSendPerf,
            isLoading: isLoading,
        },
        {
            id: 'update',
            label: 'Обновить исполнения из ЕИС',
            onClick: actions.update,
            visibleCondition: (isAdmin || isSpecialist) && isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect ? 'hover:bg-[#FFFFFF] dark:hover:bg-[#656365]' : ''}`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M19.91,15.51H15.38a1,1,0,0,0,0,2h2.4A8,8,0,0,1,4,12a1,1,0,0,0-2,0,10,10,0,0,0,16.88,7.23V21a1,1,0,0,0,2,0V16.5A1,1,0,0,0,19.91,15.51ZM12,2A10,10,0,0,0,5.12,4.77V3a1,1,0,0,0-2,0V7.5a1,1,0,0,0,1,1h4.5a1,1,0,0,0,0-2H6.22A8,8,0,0,1,20,12a1,1,0,0,0,2,0A10,10,0,0,0,12,2Z',
            disabled: !isSelect,
            isLoading: isLoading,
        },
        {
            id: 'delete',
            label: 'Удалить',
            onClick: actions.delete,
            visibleCondition: !isPerfInEisStage && !isSentToEisStage,
            className: `w-6 h-6 grid rounded-full place-items-center  ${isSelect ? 'hover:bg-[#ed9cae] dark:hover:bg-[#701f1f]' : ''}`,
            iconFill: `${isSelect ? (theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`,
            iconPathD:
                'M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z',
            disabled: !isSelect,
            isLoading: false,
        },
        {
            id: 'filter',
            label: `${isFilter ? 'Отключить фильтр' : 'Фильтр'}`,
            onClick: actions.filter,
            visibleCondition: true,
            className: `w-6 h-6 grid rounded-full place-items-center  hover:bg-[#FFFFFF] dark:hover:bg-[#656365]`,
            iconFill: `${theme == 'dark' ? '#FFFFFF' : '#181818'}`,
            iconPathD: `${
                isFilter
                    ? 'M19.22,6H12.66a1,1,0,0,0,0,2h6.56a.78.78,0,0,1,.78.78v.78H16.22a1,1,0,1,0,0,2h2.37l-.7.69a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l1.88-1.88a2.51,2.51,0,0,0,.54-.8h0l0-.1A2.59,2.59,0,0,0,22,9.82v-1A2.79,2.79,0,0,0,19.22,6ZM3.71,2.29A1,1,0,0,0,2.29,3.71L5.14,6.55A2.73,2.73,0,0,0,4,8.78v1a2.65,2.65,0,0,0,.24,1.1l0,.06a2.61,2.61,0,0,0,.54.81l5.41,5.4V21a1,1,0,0,0,.47.85,1,1,0,0,0,.53.15,1,1,0,0,0,.45-.11l3.56-1.78a1,1,0,0,0,.55-.89v-2h0l4.51,4.52a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42ZM6,8.78a.76.76,0,0,1,.5-.72L6.59,8,8.15,9.56H6Zm8.07,7.29a1,1,0,0,0-.29.71V18.6l-1.56.78v-2.6a1,1,0,0,0-.29-.71L7.41,11.56h2.74l4.22,4.22Z'
                    : 'M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z'
            }`,
            disabled: false,
            isLoading: false,
        },
    ]

    return (
        <>
            {buttons
                .filter((button) => button.visibleCondition) // Оставляем только видимые кнопки
                .map((button, index) => (
                    <button
                        key={index}
                        className={button.className}
                        onClick={button.onClick}
                        disabled={button.disabled}
                    >
                        {button.isLoading ? (
                            <HoverTooltip tooltipText={button.label}>
                                <svg
                                    className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                    ></path>
                                </svg>
                            </HoverTooltip>
                        ) : (
                            <HoverTooltip tooltipText={button.label}>
                                <svg
                                    className="w-4 h-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id={button.id}
                                >
                                    <path
                                        fill={button.iconFill}
                                        d={button.iconPathD}
                                    ></path>
                                </svg>
                            </HoverTooltip>
                        )}
                    </button>
                ))}
        </>
    )
}

export default TableStageToolbarButtons
